// internal
import { axios, def, handleError, handleResponse } from './internal';

// client-shared
import { storage } from '@goldblack/client-storage';

function AdminObjectAdd(service, type, data, onSuccess) {
    storage.transience.setState(`${service}.${type}.loading`, true);

    axios
        .post('/api/admin_object_add', {
            service,
            type,
            data,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const result = res.data.data;
                    storage.transience.addState(`${service}.${type}.data`, result);

                    onSuccess?.(result);
                    storage.transience.setState('internal.success', 'The item has been added.');
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            storage.transience.setState(`${service}.${type}.loading`, false);
        });
}

export { AdminObjectAdd };
